// extracted by mini-css-extract-plugin
module.exports = {"login_btn":"submit_login_btn__2y8iU","btn":"submit_btn__2vIJV","txtWrap":"submit_txtWrap__2TmbS","link":"submit_link__2Q4gp","txt":"submit_txt__1ZKzk"};